import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IProccess } from 'src/app/interfaces/proccess.interface';
import { ProcessService } from 'src/app/app-core/services/process.service';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import { UserService } from 'src/app/app-core/services/user.service';
import { Router } from '@angular/router';
import { CryptoService } from 'src/app/app-core/services/crypto.service';

@Component({
    selector: 'app-apensacao-processo',
    templateUrl: './apensacao-processo.component.html',
})
export class ApensacaoProcessoComponent implements OnInit {
    @Input() process: IProccess;
    @Output() reloadProcess = new EventEmitter<void>();

    public nupBusca: string = '';
    public processoEncontrado: any = null;
    public justificativa: string = '';
    public justificativaDesapensacao: string = '';
    public apensacaoSelecionada: any = null;
    public isLoadingBusca: boolean = false;
    public isLoadingApensar: boolean = false;
    public isLoadingDesapensar: boolean = false;
    public erroBusca: string = '';
    public modalDesapensacaoVisivel: boolean = false;

    constructor(
        private processService: ProcessService,
        public global: GlobalService,
        public userService: UserService,
        private router: Router,
        private cryptoService: CryptoService,
    ) {}

    ngOnInit(): void {}

    get isResponsavelOuAdmin(): boolean {
        return (
            !this.userService.isCidadao() &&
            (
                this.process?.PRC_CodigoResponsavel === this.global.user()?.PE_CodigoPessoa ||
                this.userService.isAdmin()
            )
        );
    }

    get isApensador(): boolean {
        return this.process?.apensados?.length > 0;
    }

    get isApensado(): boolean {
        return !!this.process?.PRC_CodigoProcessoApensador;
    }

    buscarProcesso(): void {
        if (!this.nupBusca.trim()) {
            this.erroBusca = 'Informe o NUP do processo a apensar';
            return;
        }

        if (this.nupBusca.trim() === this.process.PRC_NumeroProcesso) {
            this.erroBusca = 'Não é possível apensar um processo a ele mesmo';
            return;
        }

        this.erroBusca = '';
        this.processoEncontrado = null;
        this.isLoadingBusca = true;

        this.processService.buscarParaApensar(this.process.PRC_CodigoProcesso, {
            nup: this.nupBusca.trim(),
            PE_CodigoPessoa: this.global.user().PE_CodigoPessoa,
        }).subscribe({
            next: (res) => {
                this.processoEncontrado = res;
                this.isLoadingBusca = false;
            },
            error: (err) => {
                this.erroBusca = err?.error?.message || 'Processo não encontrado';
                this.isLoadingBusca = false;
            },
        });
    }

    confirmarApensacao(): void {
        if (!this.justificativa.trim()) return;

        this.isLoadingApensar = true;

        this.processService.apensarProcesso(this.process.PRC_CodigoProcesso, {
            PA_CodigoProcessoApensado: this.processoEncontrado.PRC_CodigoProcesso,
            PA_Justificativa: this.justificativa,
            PE_CodigoPessoa: this.global.user().PE_CodigoPessoa,
            PE_Nome: this.global.user().PE_Nome,
        }).subscribe({
            next: () => {
                this.isLoadingApensar = false;
                this.nupBusca = '';
                this.justificativa = '';
                this.processoEncontrado = null;
                this.reloadProcess.emit();
            },
            error: () => {
                this.isLoadingApensar = false;
            },
        });
    }

    abrirModalDesapensar(apensacao: any): void {
        this.apensacaoSelecionada = apensacao;
        this.justificativaDesapensacao = '';
        this.modalDesapensacaoVisivel = true;
    }

    confirmarDesapensacao(): void {
        if (!this.justificativaDesapensacao.trim()) return;

        this.isLoadingDesapensar = true;

        this.processService.desapensarProcesso(
            this.process.PRC_CodigoProcesso,
            this.apensacaoSelecionada.PA_CodigoApensacao,
            {
                PA_JustificativaDesapensacao: this.justificativaDesapensacao,
                PE_Nome: this.global.user().PE_Nome,
            }
        ).subscribe({
            next: () => {
                this.isLoadingDesapensar = false;
                this.modalDesapensacaoVisivel = false;
                this.apensacaoSelecionada = null;
                this.reloadProcess.emit();
            },
            error: () => {
                this.isLoadingDesapensar = false;
            },
        });
    }

    visualizarProcesso(codigoProcesso: number): void {
        const encryptedId = this.cryptoService.encrypt(String(codigoProcesso));
        this.router.navigate(['/process/view', encryptedId]);
    }

    getStatusLabel(status: number): string {
        return this.processService.getStatusDescription(status);
    }
}
